/**
 * Stores build information about <b>this specific version of the `ruffle-core` library</b>.
 *
 * It does not represent the version of Ruffle that may be in use by the page (for example, if a browser extension overrides it).
 *
 * @privateRemarks
 * This is generated at build time via `set_version.ts`.
 */
export const buildInfo = {
    versionNumber: "0.1.0",
    versionName: "0.1.0 nightly 2025-04-27",
    versionChannel: "nightly",
    buildDate: "2025-04-27T00:07:10.485Z",
    commitHash: "338fad2ec7aac03412ee037ec6329b681cf212c3",
};
